export default function (...args)
{
	return {
		regex: /^([a-z]{3,10}(?:[_.][a-z]{3,10})?)$/i,
		setValue(value, _this = this)
		{
			this.safeProtoCall(value?.toLowerCase(), _this);
		}
	};
}

